// extracted by mini-css-extract-plugin
export default {"content":"PlaybookShell_content__ap+Lc","wide":"PlaybookShell_wide__CWdNX"};